import axios from '@utils/axiosInstance'

const BASE = process.env.VUE_APP_BACKEND_PUBLIC_URL

const getDefaultState = () => {
    return {
        accessDeviceFiles: [],
        accessDeviceData: JSON.parse(localStorage.getItem('accessDeviceData'))
            ? JSON.parse(localStorage.getItem('accessDeviceData'))
            : [],
    }
}
export const state = getDefaultState()

export const getters = {}

export const mutations = {
    UPDATE_ACCESS_DEVICE_FILES(state, files) {
        state.accessDeviceFiles = files
    },
    UPDATE_DATA_WEEK(state, accessDeviceData) {
        localStorage.setItem('accessDeviceData', JSON.stringify(accessDeviceData))
        state.accessDeviceData = accessDeviceData
    },

}

export const actions = {
    async fetchAccessDeviceFiles(store) {
        store.commit('UPDATE_ACCESS_DEVICE_FILES', [])
        try {
            const res = await axios.get(`${BASE}/mx/api/AccessDeviceFiles/`)
            store.commit('UPDATE_ACCESS_DEVICE_FILES', res.data)
            return res.data
        } catch (error) {
            throw new Error(
                `API Error occurred. ${BASE}/mx/api/AccessDeviceFiles ${error}`,
            )
        }
    },
    async deleteAccessDeviceFileAction({store}, payload) {
        try {
            return await axios.post(
                `${BASE}/mx/api/AccessDeviceFiles/remove`,
                payload
            )
        } catch (e) {
            throw Error(
                `API Error occurred at /mx/api/AccessDeviceFiles/remove`,
            )
        }
    },
    async uploadAccessDeviceFileAction({store}, payload) {
        try {
            return await axios
                .post(
                    `${BASE}/mx/api/AccessDeviceFiles/upload`,
                    payload,
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        }
                    }
                )
        } catch (e) {
            throw Error(`API Error occurred at /mx/api/AccessDeviceFiles/upload`)
        }
    },
    async fetchAccessDeviceData({commit}, payload) {
        const accessDeviceDataFromLS = JSON.parse(
            localStorage.getItem('accessDeviceData'),
        )
        if (!accessDeviceDataFromLS || (accessDeviceDataFromLS && accessDeviceDataFromLS.length === 0)) {
            let accessDeviceData = []
            commit('UPDATE_DATA_WEEK', [])
            try {
                const response = await axios.get(`${BASE}/mx/api/AccessDeviceData/${payload.personnelDivision}/${payload.date}`)
                if (response.data.length > 0) {
                    accessDeviceData = response.data
                    commit('UPDATE_DATA_WEEK', accessDeviceData)
                }
                return accessDeviceData
            } catch (error) {
                throw new Error(
                    `API Error occurred. ${BASE}/mx/api/AccessDeviceData/${payload.personnelDivision}/${payload.date} ${error}`,
                )
            }
        }
    },
}